import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import BookingInvoices from './Bookinginvoices';
import PlanInvoices from './Planinvoices';
import { FileText, Calendar, Menu } from 'lucide-react';

export default function Finance() {
  const [activeTab, setActiveTab] = useState('bookings');
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const tabs = [
    { id: 'bookings', label: 'Bookings', icon: Calendar },
    { id: 'plans', label: 'Plans', icon: FileText },
  ];

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <Sidebar 
        currentPath="/finance" 
        mobileOpen={mobileSidebarOpen}
        onMobileClose={() => setMobileSidebarOpen(false)}
      />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        {/* ── Mobile top bar ── */}
        <header className="md:hidden flex items-center justify-between px-4 py-3 bg-white border-b border-gray-200 sticky top-0 z-30">
          <button
            className="p-2 rounded-md text-gray-600 hover:bg-gray-100 transition-colors"
            onClick={() => setMobileSidebarOpen(true)}
            aria-label="Open menu"
          >
            <Menu className="w-5 h-5" />
          </button>
          <img
            src="/logo.png"
            alt="Optimus Logo"
            className="h-7 w-auto object-contain mr-5"
          />
        </header>

        <main className="flex-1 overflow-y-auto bg-gray-50">
          <div className="p-4 md:p-8">
            <div className="mb-6">
              <h1 className="text-2xl font-semibold text-gray-900 mb-1">Finance</h1>
              <p className="text-sm text-gray-500">Manage invoices and financial records</p>
            </div>

            <div>
              <div className="border-b border-gray-200 overflow-x-auto -mx-4 md:mx-0 px-4 md:px-0">
                <div className="flex min-w-max">
                  {tabs.map((tab) => {
                    const Icon = tab.icon;
                    return (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-2 px-6 py-4 text-sm font-medium border-b-2 transition-colors ${
                          activeTab === tab.id
                            ? 'border-blue-600 text-blue-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700'
                        }`}
                      >
                        <Icon className="w-4 h-4" />
                        {tab.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="py-4 md:p-6">
                {activeTab === 'bookings' && <BookingInvoices />}
                {activeTab === 'plans' && <PlanInvoices />}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}